import { makeApi } from "@zodios/core";
import { z } from "zod";

import { escPreinterventionEstimationResponseDtoSchema } from "@/types/backoffice/dto/esc/esc-preintervention-estimation-response-dto.ts";
import {
  ESubscriberSignatureStatus,
  signatureDetailsDtoSchema,
} from "@/types/backoffice/dto/signature/signature-details-dto.ts";

export const backofficeSignatureApi = makeApi([
  {
    method: "post",
    path: "/site/:siteId/preintervention-estimate",
    response: escPreinterventionEstimationResponseDtoSchema,
    alias: "generateESCPreinterventionEstimate",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
      {
        type: "Body",
        name: "body",
        schema: z.any(),
      },
    ],
  },
  {
    method: "get",
    path: "/:subscriberSignatureId/getStatus",
    response: z.object({ status: z.nativeEnum(ESubscriberSignatureStatus) }),
    alias: "findSignatureStatus",
    parameters: [
      {
        type: "Path",
        name: "subscriberSignatureId",
        schema: z.number(),
      },
    ],
  },
  {
    method: "get",
    path: "/site/:siteId",
    response: signatureDetailsDtoSchema,
    alias: "findSiteSignatureDetails",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
  },
  {
    method: "post",
    path: "/:subscriberSignatureId/send-reminder",
    response: z.any(),
    alias: "sendSignatureReminder",
    parameters: [
      {
        type: "Path",
        name: "subscriberSignatureId",
        schema: z.number(),
      },
    ],
  },
  {
    method: "post",
    path: "/:subscriberSignatureId/cancel",
    response: z.any(),
    alias: "cancelSignature",
    parameters: [
      {
        type: "Path",
        name: "subscriberSignatureId",
        schema: z.number(),
      },
    ],
  },
  {
    method: "post",
    path: "/site/:siteId/customer-service-certificate",
    response: z.unknown(),
    alias: "sendCustomerServiceCertificate",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
  },
]);
